import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'
import { useCallback, useMemo, useState } from 'react'
import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'
import ECharts from '~/components/echarts'
import Select from '~/components/select'
import { awsLoadBalancerRequestCountMetricsResourceIdChartPath } from '~/routes'

export default function AWSLoadBalancerMetricsCharts({ organizationId: orgId, resourceId: reId }) {
  const [params, setParams] = useState({ metrics_time_frame: '1w' })
  const metricsTimeFrames = useMemo(
    () => [
      { label: t`1 Week`, value: '1w', default: true },
      { label: t`1 Month`, value: '1m' },
      { label: t`3 Months`, value: '3m' },
    ],
    [],
  )

  const onChange = useCallback((name, values) => {
    // update params when a filter is selected
    setParams((prevParams) => ({ ...prevParams, [name]: values }))
  }, [])

  const requestCountChartUrl = useMemo(
    () => awsLoadBalancerRequestCountMetricsResourceIdChartPath(orgId, reId),
    [orgId, reId],
  )

  return (
    <div className='card'>
      <h3 className='card-header'>
        <Trans>Metrics</Trans>
      </h3>
      <div className='card-body'>
        <div className='row mb-3 gx-2 gy-2 align-items-center'>
          <div className='col-sm-4'>
            <Select
              label={t`Time Frame`}
              name='metrics_time_frame'
              onChange={onChange}
              options={metricsTimeFrames}
              selected={params.metrics_time_frame}
            />
          </div>
        </div>
        <Tabs id='uncontrolled-metrics-tabs' className='mb-3'>
          <Tab eventKey='request-tab' title={t`Requests`} mountOnEnter>
            <div className='row g-0'>
              <div className='col-sm-12'>
                <ECharts
                  title={t`Request Count`}
                  chartInfoTitle='aws_lb_request_count'
                  url={requestCountChartUrl}
                  params={params}
                />
              </div>
            </div>
          </Tab>
        </Tabs>
      </div>
    </div>
  )
}
